import CreateListResourceInteractor from "../../core/interactor/app/crud/CreateListResourceInteractor";
import { IOrganisationIndex } from "../../organisations/model/OrganisationIndex";
import { ICaseLawDocument } from "../model/CaseLawDocument";

export default class AddItemsToCaseLawDocumentInteractor {
  private createListResource: CreateListResourceInteractor<IOrganisationIndex>;

  constructor({ createListResource }: any) {
    this.createListResource = createListResource;
  }

  async execute(model: ICaseLawDocument, items: IOrganisationIndex[]) {
    return this.createListResource.execute(
      "/case-law-documents/indexes",
      items,
      {
        query: { caseLawDocumentId: model.id }
      }
    );
  }
}
